module.exports = __webpack_public_path__ + "img/stars-4--alt.50ffb63.svg";